import React from 'react';
import './ScrollToAccept.css';
import {TCCheckbox} from "../tc_checkbox/TCCheckbox";

export class ScrollToAccept extends React.Component {
  constructor(props) {
    super(props);

    this.scrollRef = React.createRef();

    this.state = {
      scrolledToBottom: false,
      checked: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    //set initial state
    this.setState({
      scrolledToBottom: this.isAtBottom(this.scrollRef.current),
    });
  }

  isAtBottom(elem) {
    //added 10 as a fudge factor because I'm tired of redoing this, so within 10 pixels from bottom is cool
    const isBottom = elem.scrollHeight - elem.scrollTop - elem.clientHeight < 10;
    //console.log("bottom? ", isBottom, elem.scrollHeight - elem.scrollTop, elem.clientHeight, elem.scrollHeight - elem.scrollTop - elem.clientHeight);
    return isBottom;
  }

  handleChange(e) {
    const checked = e.target.checked;
    this.setState({checked: checked});
    this.props.onChange(checked);
  };

  handleScroll(e) {
    if (!this.state.scrolledToBottom) {
      const bottom = this.isAtBottom(e.target);
      if (bottom) {
        this.setState({scrolledToBottom: true});
      }
    }
  };

  render() {
    return (
        <div className={this.props.className || ''}>
          <hr/>
          <div className='scroll-text' onScroll={this.handleScroll}
               tabIndex={0} ref={this.scrollRef}>
            {this.props.children}
            {/* For test automation scripts to get to end of the scroll window */}
            <div className="test-automation-end-scroll"></div>
          </div>
          <hr/>
          <TCCheckbox disabled={!this.state.scrolledToBottom || this.props.disabled}
                    checked={this.state.checked}
                    onChange={this.handleChange}>
                    {this.props.checkboxLabel}
          </TCCheckbox>
        </div>
    );
  }
}

